"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Link = exports.LinkText = exports.LinkList = void 0;
const styled_components_1 = __importDefault(require("styled-components"));
const Typography_1 = __importDefault(require("../Typography"));
exports.LinkList = styled_components_1.default.div `
  display: flex;
  flex-direction: column;
  row-gap: ${props => props.rowGap}px;
`;
exports.LinkText = (0, styled_components_1.default)(Typography_1.default) `
  margin: 0;
`;
exports.Link = styled_components_1.default.a `
  color: ${props => props.theme.palette.BW_0};
  font-size: inherit;
  text-decoration: none;

  :active,
  :visited {
    color: ${props => props.theme.palette.BW_0};
  }
`;
exports.default = {
    LinkList: exports.LinkList,
    LinkText: exports.LinkText,
    Link: exports.Link
};
